import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { ref, computed } from 'vue';


const __default__ = { name: 'ReportFilterDate' }


export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    data: {},
    loader: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;

// Dark mode
const isDarkMode = ref(window.matchMedia('(prefers-color-scheme: dark)').matches);
window.matchMedia('(prefers-color-scheme: dark)')
  .addEventListener('change', e => isDarkMode.value = e.matches);

// Loader
const reportLoader = computed(() => props.loader ?? false);

// Series
const chartSeries = computed(() => [
  {
    name: 'Cotizaciones',
    data: (props.data || []).map(user => parseFloat(user.cotizaciones) || 0),
  },
]);

// === Paletas dinámicas por hostname ===
const hostname = window.location.hostname;

const dominiomediosPalette = [
  '#be103b', '#88102e', '#6e0f26', '#a1293a',
  '#944249', '#b5696d', '#be103b'
];

const blueScaleBase = [
  '#1e3a8a', // blue-900
  '#1d4ed8', // blue-700
  '#2563eb', // azul solicitado
  '#3b82f6', // blue-500
  '#60a5fa', // blue-400
  '#93c5fd', // blue-300
  '#bfdbfe'  // blue-200
];

const computedColors = computed(() => {
  const n = (props.data || []).length || 1;

  const base = (hostname === 'crm.dominiomedios.com')
    ? dominiomediosPalette
    : blueScaleBase;

  if (n <= base.length) return base.slice(0, n);
  // ciclar si hay más barras que colores
  return Array.from({ length: n }, (_, i) => base[i % base.length]);
});

// Options
const chartOptions = computed(() => ({
  chart: {
    type: 'bar',
    foreColor: isDarkMode.value ? '#fff' : '#333',
    toolbar: { show: false },
  },
  plotOptions: {
    bar: {
      distributed: true,          // ← importante para que use colors por barra
      dataLabels: { orientation: 'vertical' },
      columnWidth: '40%',
      borderRadius: 4,
    },
  },
  dataLabels: {
    enabled: true,
    offsetX: 0,
    offsetY: 20,
    style: {
      colors: [isDarkMode.value ? '#fff' : '#333'],
      fontWeight: 'bold',
      textShadow: '2px 2px 2px rgba(0,0,0,0.25)'
    },
    formatter: (_val: number, opt: any) => {
      const i = opt?.dataPointIndex ?? 0;
      const u = props.data?.[i];
      const total = parseFloat(u?.total_cotizado ?? 0) || 0;
      return total.toLocaleString('es-MX', { style: 'currency', currency: 'MXN' });
    },
  },
  xaxis: {
    categories: (props.data || []).map(user => user.vendedor ?? 'Sin nombre'),
    labels: {
      rotate: -40,
      style: {
        colors: isDarkMode.value ? '#ccc' : '#666',
        fontSize: '14px',
      },
    },
  },
  yaxis: {
    min: 0,
    forceNiceScale: true,
    labels: {
      formatter: (val: number) => (Number.isInteger(val) ? val : ''),
      style: {
        colors: isDarkMode.value ? '#ccc' : '#666',
        fontSize: '14px',
      },
    },
  },
  tooltip: {
    theme: isDarkMode.value ? 'dark' : 'light',
    y: {
      formatter: (_val: number, { dataPointIndex }: any) =>
        (parseFloat(props.data?.[dataPointIndex]?.total_cotizado ?? 0) || 0)
          .toLocaleString('es-MX', { style: 'currency', currency: 'MXN' }),
    },
  },
  colors: computedColors.value,   // ← paleta dinámica
  legend: { show: false },
  grid: {
    borderColor: isDarkMode.value ? '#444' : '#eee',
    xaxis: { lines: { show: false } },
    yaxis: { lines: { show: true } },
  },
}));

return (_ctx: any,_cache: any) => {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_progress_linear = _resolveComponent("v-progress-linear")!
  const _component_apexchart = _resolveComponent("apexchart")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, {
    flat: "",
    class: "pa-6 pr-3"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card_title, null, {
        default: _withCtx(() => _cache[0] || (_cache[0] = [
          _createTextVNode("Cotizaciones por Usuario")
        ])),
        _: 1,
        __: [0]
      }),
      (reportLoader.value)
        ? (_openBlock(), _createBlock(_component_v_progress_linear, {
            key: 0,
            indeterminate: "",
            color: "primary"
          }))
        : (_openBlock(), _createBlock(_component_apexchart, {
            key: 1,
            type: "bar",
            height: "400",
            options: chartOptions.value,
            series: chartSeries.value
          }, null, 8, ["options", "series"]))
    ]),
    _: 1
  }))
}
}

})